import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyA0JDwxUmp2BBFZtSF_HES3A1T7Vs-C_pM",
  authDomain: "weather-report-541eb.firebaseapp.com",
  projectId: "weather-report-541eb",
  storageBucket: "weather-report-541eb.firebasestorage.app",
  messagingSenderId: "667630979245",
  appId: "1:667630979245:web:2e61a09ca2ff586a37de24",
  measurementId: "G-8S78KGTKND"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
